<template>
  <div :class="['home', gonggeshow == 1 ? 'activeHome' : '']">
    <!-- v-if="delay" -->
    <AochenHead
      :InstanceList="InstanceList"
      :bannerList="bannerList"
      :countDownObj="countDownObj"
      @GroupList="GroupList"
      @updateGroup="getinstancelist"
      @signInClick="signInClick_father"
      v-if="delay"
    />
    <div class="main">
      <div v-if="gonggeshow == 1">
        <!-- v-if="delay" -->
        <Singlecard
          :gonggeshow="gonggeshow"
          :InstanceList="InstanceList"
          :buyShow="buyShow"
          :getShow="getShow"
          v-if="delay"
        />
      </div>
      <div v-if="gonggeshow == 4 || gonggeshow == 9 || gonggeshow == 16">
        <!-- v-if="delay" -->
        <Fourboxgrid
          :gonggeshow="gonggeshow"
          :InstanceList="InstanceList"
          :getShow="getShow"
        />
      </div>
      <!-- <div v-if="gonggeshow == 9">
        <Nineboxgrid
          v-if="flag"
          :gonggeshow="gonggeshow"
          :InstanceList="InstanceList"
        />
      </div> -->
    </div>
    <!-- 进入时的弹窗 -->
    <div class="remincla" v-if="reminder">
      <van-popup
        class="webImageImgPopup"
        :style="{ width: !reminder.imageUrl ? '80%' : '80%' }"
        v-model="reminder_show"
        v-if="reminder.imageUrl || reminder.content"
      >
        <div class="remi_img">
          <img
            class="webImageImg"
            v-if="reminder.imageUrl"
            :src="reminder.imageUrl"
            alt=""
            @click="remintz"
          />
          <div v-else class="remi_bt">
            <div class="remi_btP1">{{ reminder.title }}</div>
            <div class="remi_btP2" style="white-space: pre-wrap">
              {{ reminder.content }}
            </div>
          </div>
        </div>
        <div class="remi_guanbi" @click="reminder_show = false">
          <img src="../../assets/icons/guanbi.png" alt="" />
        </div>
      </van-popup>
    </div>
    <!-- <BgsSdk ref="child_BgsSdk" /> -->
    <AochenFooter></AochenFooter>
    <toAppStore :isTitle="true" ref="sonShow"></toAppStore>
    <SignInPopup
      :signInShow="signInShow"
      :signInObj="signInObj"
      @closeChildDialog="closeChildDialog"
      @getSignInlist="getSignInlist"
      v-if="delay"
    ></SignInPopup>
    <div v-if="countDownIconShow && new_group_buyShow != '1'">
      <!--  v-if="timeCountDown > 0 && isEnd == '0'" -->
      <div class="countDownOpenJump" @click="countDownJump">
        <img
          class="closeCountDown"
          src="../../assets/img/activity/massiveGroupBuying/x.png"
          alt=""
          @click.stop="CountDownClose"
        />
        <!-- <van-count-down
          class="timeName"
          :time="timeCountDown"
          format="HH 时 mm 分 ss 秒"
        /> -->
        <div class="timeName">双十一狂欢</div>
      </div>
      <!-- <div class="countDownJump" @click="countDownJump" v-else>
        <img
          class="closeCountDown"
          src="../../assets/img/activity/massiveGroupBuying/x.png"
          alt=""
          @click.stop="CountDownClose"
        />
      </div> -->
    </div>
    <van-overlay :show="showGuide" z-index="9999">
      <div class="wrapper" @click.stop>
        <div class="describeBox">
          <div class="skipBox">
            <van-button
              class="skip"
              round
              type="default"
              @click="skipInstructions"
              >跳过引导</van-button
            >
          </div>
          <div class="name">设备转移功能上线啦，跟着引导前往转移</div>
          <van-button class="leaveFor" round type="info" @click="toMine"
            >前往转移</van-button
          >
          <img
            class="pointImg"
            src="../../assets/img/homeAmend/point_right.png"
            alt=""
          />
        </div>
        <div class="block" @click="toMine"></div>
      </div>
    </van-overlay>
    <dialogHint
      :dialogShow="dialogShow"
      :dialogTitle="dialogTitle"
      @dialogClic="confirms"
    >
      <template v-slot:content>{{ dialogName }}</template>
    </dialogHint>
    <van-popup
      class="channelErrorPopup"
      v-model="channelErrorShow"
      :close-on-click-overlay="false"
      ><div class="channelError">
        <div class="title">提示</div>
        <div>您用于注册的链接不完整，请重新复制完整注册链接。</div>
      </div></van-popup
    >
  </div>
</template>

<script>
// @ is an alias to /src
import AochenFooter from "@/components/AochenFooter";
import AochenHead from "@/components/AochenHead";
import BgsSdk from "@/components/BgsSdk";
import Floating from "@/components/Floating.vue";
import Singlecard from "@/components/cell/Singlecard.vue";
import Fourboxgrid from "@/components/cell/Four_boxgrid.vue";
import Nineboxgrid from "@/components/cell/nine_boxgrid.vue";
import SignInPopup from "@/components/cell/SignInPopup.vue";
import toAppStore from "@/components/activityGather/toAppStore.vue";
import dialogHint from "@/components/publicModule/dialogHint.vue";

import {
  instancelist,
  activityreminder,
  regWelfare,
  groupAndRedData,
  sysConfigByConfigKey,
  signInlist,
  activityBanner,
  remoteLoginReminder,
  channelcodelist,
} from "../../api/index.js";
import { Toast } from "vant";
import { mapState, mapMutations } from "vuex";

export default {
  name: "HomeView",
  provide() {
    // 在爷爷组件中提供一个方法
    return {
      grandpaGetinstancelist: this.getinstancelist,
    };
  },
  components: {
    // 底部
    AochenFooter,
    // 头部
    AochenHead,
    // sdk
    BgsSdk,
    // sdk悬浮球
    Floating,
    // 单卡片内容区域
    Singlecard,
    // 4宫格
    Fourboxgrid,
    // 9宫格
    Nineboxgrid,
    // 苹果跳appstore弹窗
    toAppStore,
    // 签到
    SignInPopup,
    dialogHint,
  },
  data() {
    return {
      integer: 0,
      InstanceList: [],
      groupingForList: [],
      userdata: null,
      reminder: null,
      reminder_show: false,
      gonggeshow: -1,
      flag: false,
      delay: false,
      buyShow: false,
      getShow: false,
      timer: null,
      signInShow: false,
      countDownObj: {},
      timeCountDown: 0,
      new_group_buyShow: "1",
      signInObj: {},
      isEnd: "1",
      showGuide: false,
      bannerList: [],
      dialogShow: false,
      dialogTitle: "温馨提示",
      dialogName: "",
      channelErrorShow: false,
    };
  },
  mounted() {
    // const fpPromise = new Promise((resolve, reject) => {
    //     const script = document.createElement('script')
    //     script.onload = resolve
    //     script.onerror = reject
    //     script.async = true
    //     script.src = 'https://cdn.jsdelivr.net/npm/'
    //         + '@fingerprintjs/fingerprintjs@3/dist/fp.min.js'
    //     document.head.appendChild(script)
    // })
    //     .then(() => FingerprintJS.load())

    // // Get the visitor identifier when you need it.
    // fpPromise.then(fp => fp.get()).then(result => {
    //     // This is the visitor identifier:
    //     const visitorId = result.visitorId
    //     console.log('唯一标识:' + visitorId)
    // })
    let that = this;
    that.getinstancelist();
    this.getActivityBanner();
    let channelCode;
    if (that.$route.query.channelCode) {
      if (this.isBase64(that.$route.query.channelCode)) {
        channelCode = { channelCode: atob(that.$route.query.channelCode) };
      } else {
        channelCode = {
          channelCode: that.$route.query.channelCode.replace(/"/g, ""),
        };
      }
      channelcodelist().then((res) => {
        if (res.code == 200) {
          // 是否与后台已经生成存在的渠道匹配
          const isFound = res.data.includes(channelCode.channelCode);
          if (!isFound) {
            this.channelErrorShow = true;
          } else {
            sessionStorage.setItem("channelCode", JSON.stringify(channelCode));
          }
        }
      });
    } else {
      let _channelCode = JSON.parse(sessionStorage.getItem("channelCode"));
      if (!_channelCode) {
        channelCode = { channelCode: "ac" };
        sessionStorage.setItem("channelCode", JSON.stringify(channelCode));
      }
    }
    if (Boolean(that.$route.query.applePush)) {
      this.SET_APPLEPUSHSHOW(Boolean(that.$route.query.applePush));
    }
    that.userdata = JSON.parse(localStorage.getItem("data"));
    if (that.userdata) {
      that.getactivityreminder();
      if (this.recordLong) {
        that.getRegWelfare();
        if (this.$route.params.isSuccess) {
          remoteLoginReminder().then((res) => {
            if (res.data != "") {
              this.dialogName = res.data;
              this.dialogShow = true;
            }
          });
        }
      }
      // // 新手引导
      // let isNoviceGuideShow = JSON.parse(
      //   localStorage.getItem("noviceGuideShow")
      // );
      // if (!isNoviceGuideShow) {
      //   this.showGuide = true;
      //   const shiftElement = document.querySelector(".navnameBox");
      //   const clonedNode = document.querySelector(".block");
      //   clonedNode.innerHTML = shiftElement.outerHTML;
      //   this.width = shiftElement.offsetWidth;
      //   this.height = shiftElement.offsetHeight;
      //   clonedNode.style.width = this.width + "px";
      //   clonedNode.style.height = this.height + "px";
      // }
    }
    // let gongge = sessionStorage.getItem("gonggeshow");
    // if (gongge != null) {
    //   this.gonggeshow = gongge-1;
    // }
    // 延迟渲染子组件
    // this.timer = setInterval(() => {
    this.flag = true;
    // }, 200);
    // this.$nextTick(() => {
    //   this.flag = true;
    // });
    let show = localStorage.getItem("homeMessage");
    if (show != null) {
      this.gonggeqiehuan(Number(show));
    } else {
      this.gonggeqiehuan(1);
    }
  },
  computed: {
    //数组写法
    ...mapState("common", ["recordLong", "applePushShow", "countDownIconShow"]),
  },
  methods: {
    confirms(msg) {
      this.dialogShow = msg;
    },
    toMine() {
      this.$router.push({ path: "/mine" });
      this.showGuide = false;
    },
    skipInstructions() {
      this.showGuide = false;
      localStorage.setItem("noviceGuideShow", true);
    },
    getSignInlist() {
      signInlist().then((res) => {
        this.signInObj = res.data;
      });
    },
    getGroupBuying() {
      groupAndRedData().then((res) => {
        if (res.code == 200) {
          this.isEnd = res.data.isEnd;
          this.timeCountDown = res.data.countdown;
        }
      });
    },
    signInClick_father(e) {
      this.signInShow = e;
    },
    closeChildDialog(e) {
      this.signInShow = e;
      this.getinstancelist();
    },
    ...mapMutations("common", [
      "SET_RECORDLONG",
      "SET_APPLEPUSHSHOW",
      "SET_COUNTDOWNICONSHOW",
    ]),
    getRegWelfare() {
      let data = {};
      regWelfare(data).then((res) => {
        this.SET_RECORDLONG(false);
      });
    },
    isBase64(str) {
      const regex =
        /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/;
      return regex.test(str);
    },
    // 切换宫格
    gonggeqiehuan(e) {
      // this.$nextTick(() => {
      this.gonggeshow = e;
      // sessionStorage.setItem("gonggeshow", e);
      // });
    },
    // 启动云手机
    BgsSdca(em) {
      this.userdata = JSON.parse(localStorage.getItem("data"));
      if (this.userdata) {
        // this.$refs.child_BgsSdk.getserverToken(em);
        let _em = this.groupingForList.find(function (item) {
          return item.id == em.id;
        });
        localStorage.setItem("em", JSON.stringify(_em));
        switch (_em.channelCode) {
          case "baidu":
            this.$router.push({
              params: {
                e: _em,
              },
              name: "BgsSdk",
            });
            break;
          case "huoshan":
            this.$router.push({
              params: {
                e: _em,
              },
              name: "VeSdk",
            });
            break;
          case "intelligent":
            this.$router.push({
              params: {
                e: _em,
              },
              name: "NzSdk",
            });
            break;
          case "huawei":
            this.$router.push({
              params: {
                e: _em,
              },
              name: "HwSdk",
            });
            break;
          default:
            console.log("0");
        }
      } else {
        this.$router.push("/login");
      }
    },
    // 轮播图
    getActivityBanner() {
      activityBanner().then((res) => {
        if (res.code == 200) {
          this.bannerList = res.data;
        }
      });
    },
    // 获取所有设备信息
    async getinstancelist() {
      let that = this;
      let list = JSON.parse(sessionStorage.getItem("selectiveGroup"));
      await instancelist()
        .then((res) => {
          let Show = JSON.parse(sessionStorage.getItem("countDownShow"));
          let numGroup = JSON.parse(localStorage.getItem("homeMessage")) == 1;
          this.getShow = true;
          this.delay = true;
          if (res.code == 200) {
            that.groupingForList = res.data;
            if (list == null || numGroup) {
              that.InstanceList = res.data;
              let show = localStorage.getItem("homeMessage");
              let arrLength = this.InstanceList.length;
              if (show == 4 && arrLength < 2) {
                localStorage.removeItem("homeMessage");
                this.gonggeqiehuan(1);
              } else if (show == 9 && arrLength < 5) {
                localStorage.removeItem("homeMessage");
                this.gonggeqiehuan(1);
              } else if (show == 16 && arrLength < 10) {
                localStorage.removeItem("homeMessage");
                this.gonggeqiehuan(1);
              } else if (show != null) {
                this.gonggeqiehuan(Number(show));
              }
            } else {
              that.InstanceList = list.instanceList;
            }
            for (let i = 0; i < that.InstanceList.length; i++) {
              that.InstanceList[i].endTime;
              let now = new Date();
              let targetDate = new Date(that.InstanceList[i].endTime); // 你的目标日期
              const seconds = Math.floor((targetDate - now) / 1000);
              that.InstanceList[i].countDown =
                that.InstanceList[i].expireSeconds * 1000;
              const days = Math.floor(seconds / (3600 * 24));
              that.InstanceList[i].remind = days;
              // 续费弹窗提示获取本地是否隐藏
              that.InstanceList[i].statusShow = true;
              if (Show !== null) {
                for (let j = 0; j < Show.length; j++) {
                  if (that.InstanceList[i].id == Show[j].id) {
                    if (
                      (that.InstanceList[i].expireSeconds < 86400 &&
                        Show[j].expireSeconds > 86400) ||
                      (that.InstanceList[i].expireSeconds < 259200 &&
                        Show[j].expireSeconds > 259200)
                    ) {
                      that.InstanceList[i].statusShow = true;
                    } else {
                      that.InstanceList[i].statusShow = false;
                    }
                  }
                }
              }
              // 倒计时显隐
              // 时间小于三天，满足分组续费条件，倒计时时间大于0，已经进入过了分组续费
              // 1-3天分组续费，时间大于1天，1天内分组续费，时间大于1天
              if (
                that.InstanceList[i].isAuthorized != 1 &&
                that.InstanceList[i].isGroupRenew &&
                that.InstanceList[i].expireSeconds < 259200 &&
                that.InstanceList[i].groupRenewActivityTime > 0 &&
                that.InstanceList[i].groupRenewActivityStartTime
              ) {
                if (
                  (that.InstanceList[i].isDisplay != 0 &&
                    that.InstanceList[i].expireSeconds > 86400) ||
                  (that.InstanceList[i].isDisplay == 0 &&
                    that.InstanceList[i].expireSeconds < 86400)
                ) {
                }
                // 倒计时对象
                this.countDownObj = that.InstanceList[i];
              }
            }
            if (res.data.length <= 0) {
              that.buyShow = true;
            } else {
              this.integer = "1";
            }
            this.instancelistNed();
            // that.$refs.van_swipe.swipeTo(0);
          } else if (res.code == 401) {
            that.buyShow = true;
            localStorage.removeItem("token");
            localStorage.removeItem("data");
          }
        })
        .catch((err) => {
          this.delay = true;
        });
    },
    instancelistNed() {
      setTimeout(() => {
        // if (this.countDownIconShow) {
        //   this.getGroupBuying();
        // }
        sysConfigByConfigKey({ configKey: "double_eleven" }).then((res) => {
          this.new_group_buyShow = res.data;
        });
      }, 500);
      this.$nextTick(function () {
        this.getSignInlist();
      });
    },
    // 获取活动提示
    async getactivityreminder() {
      let that = this;
      await activityreminder().then((res) => {
        if (res.code == 200) {
          if (this.applePushShow) {
            this.$refs.sonShow.ShowClick();
            this.SET_APPLEPUSHSHOW(false);
          } else {
            that.reminder = res.data;
            that.reminder_show = res.data.show;
          }
        }
      });
    },
    // 活动跳转
    remintz() {
      if (this.reminder.url) {
        location.href = this.reminder.url;
      } else {
        switch (this.reminder.activityType) {
          case 1:
            // 1.全民推广 2.激活码 3.邀请好友 4.购买设备 5.拼团活动 6.dnf手游试玩 7.qq群 10.千人团
            this.$router.push("/agencyCentre");
            break;
          case 2:
            this.$router.push("/activationconversion");
            break;
          case 3:
            this.$router.push("/invitefriends");
            break;
          case 4:
            let _vipCode = null;
            if (
              this.reminder.vipCode == "VIP1" ||
              this.reminder.vipCode == "VIP2" ||
              this.reminder.vipCode == "VIP3" ||
              this.reminder.vipCode == "VIP4"
            ) {
              _vipCode = this.reminder.vipCode.slice(-1) - 0;
            } else {
              _vipCode = this.reminder.vipCode;
            }
            this.$router.push({
              path: "/newcloudphone",
              query: { VIP: _vipCode },
            });
            break;
          case 5:
            this.$router.push("/formGroup");
            break;
          case 6:
            this.$router.push("/attemptPlay");
            break;
          case 10:
            this.$router.push("/thousandGroupBuying");
            break;
          case 11:
            this.$router.push({
              path: "/preorder",
              query: { type: 11 },
            });
            break;
          case 12:
            this.$router.push({
              path: "/preorder",
              query: { type: 12 },
            });
            break;
          case 13:
            this.$router.push({
              path: "/preorder",
              query: { type: 13 },
            });
            break;
          case 14:
            this.$router.push({
              path: "/preorder",
              query: { type: 14 },
            });
            break;
          case 7:
            location.href =
              "http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=1HSqtfJflr_eqRXMIefHixSkleP90E9_&authKey=M%2BHGZYh8wi%2F3b32qLCGn94aGlzmXQByMg6Ff2I%2BMYnC1sAGnt%2F1UJOtUTis%2FpS2A&noverify=0&group_code=462925501";
            this.reminder_show = false;
            break;
          default:
            this.reminder_show = false;
        }
      }
    },
    GroupList(List) {
      this.InstanceList = List.instanceList;
    },
    countDownJump() {
      activityBanner().then((res) => {
        if (res.code == 200) {
          this.bannerList.forEach((item) => {
            if (item.type > 10) {
              this.$router.push({
                path: "/preorder",
                query: { type: item.type },
              });
            }
          });
          this.bannerList = res.data;
        }
      });
    },
    CountDownClose() {
      this.SET_COUNTDOWNICONSHOW(false);
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  height: 100%;
  height: 100%;
  .describeBox {
    // position: absolute;
    margin: 0 0 50px 60px;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    .skipBox {
      width: 100%;
      text-align: left;
    }
    .skip {
      width: 90px;
      height: 30px;
      text-align: right;
      float: left;
      background-color: #ccc;
      color: #fff;
      border: 0;
    }
    .name {
      margin: 16px 0;
    }
    .leaveFor {
      width: 100px;
      height: 40px;
    }
    .pointImg {
      width: 80px;
    }
  }
  .block {
    background-color: #fff;
    position: absolute;
    display: inline-block;
    text-align: center;
    bottom: -8px;
    right: 32px;
    border-radius: 80px;
    img {
      width: 42px;
      height: 42px;
    }
    p {
      line-height: 13px;
      margin: 2px 0 16px 0;
      font-size: 13px;
      font-weight: 400;
      color: #666666;
    }
  }
}

/* 方法2：Webkit内核浏览器专用 */
.activeHome {
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

.activeHome::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}

/* 方法3：Firefox专用方案 */
.activeHome {
  overflow: auto;
  scrollbar-width: none;
}
.home {
  width: 100%;
  margin-bottom: 50px;
  // overflow-y: auto;
  // overflow-y: auto;
  // overflow-x: hidden;
  // touch-action: manipulation;
  // -webkit-overflow-scrolling: touch;
  // scrollbar-width: none;
  // -ms-overflow-style: none;
  height: 100%;
  background-image: url("@/assets/img/homeAmend/headBack.png");
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #fff;
  &::-webkit-scrollbar {
    display: none;
  }
  .main {
    margin-top: -10px;
  }
}

.remincla {
  .webImageImgPopup {
    // width: 90%;
    background: none;
    overflow: hidden;
  }
  .remi_img {
    // max-width: calc(100vw - 32px);
    // max-height: calc(100vh - 92px);
    margin: 16px auto 16px auto;
    .webImageImg {
      width: 100%;
    }
    .remi_bt {
      background: #fff;
      padding: 16px;
      border-radius: 10px;
      .remi_btP1 {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 10px;
      }
      .remi_btP2::-webkit-scrollbar {
        width: 0; /* 宽度设为0 */
        height: 0; /* 高度设为0 */
      }
      .remi_btP2 {
        font-size: 14px;
        overflow: auto;
        max-height: 400px;
      }
    }
    img {
      border-radius: 10px 10px 10px 10px;
    }
    overflow: hidden;
  }
  .remi_guanbi {
    img {
      width: 28px;
      height: 28px;
    }
  }
}
.countDownJump {
  position: fixed;
  max-width: 414px;
  right: 0;
  bottom: 150px;
  width: 78px;
  height: 81px;
  background-image: url("../../assets/img/activity/preorder/entrance.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .closeCountDown {
    position: absolute;
    left: 0;
    top: -10px;
    width: 15px;
    height: 15px;
  }
}
.countDownOpenJump {
  position: fixed;
  max-width: 414px;
  right: 0;
  bottom: 150px;
  width: 82px;
  height: 82px;
  background-image: url("../../assets/img/activity/preorder/entrance1.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .closeCountDown {
    position: absolute;
    left: 0;
    top: -10px;
    width: 15px;
    height: 15px;
  }
  .timeName {
    width: 62px;
    height: 12px;
    // background-color: #a67f5e;
    border-radius: 20px;
    line-height: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    // font-size: 5px;
    font-size: 10px;
    color: #fff;
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translate(-50%);
    letter-spacing: 0px;
  }
}
.channelErrorPopup {
  width: 70%;
  border-radius: 16px;
  .channelError {
    font-size: 13px;
    padding: 12px 16px 16px 16px;
    color: #2c3e50;
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }
  }
}
</style>